import { ReportType } from '@declarations/common/reportType';
import initInstance from './axios';
import setLogRecordExpertUsers from '@utils/setLogRecordExpertUsers';
import { LogRecord } from '@declarations/models/LogRecord';

const api = initInstance('/user-log-record');

export type QueryUserLogRecords = {
  reportId: number;
  reportType: ReportType;
}

const UserLogRecordService = {
  get: (queryUserLogRecords: QueryUserLogRecords) =>
    api.get<LogRecord[]>('', { params: queryUserLogRecords }).then(res => setLogRecordExpertUsers(res)),
};

export default UserLogRecordService;